import moment from 'moment';

import StatusCell from 'components/pages/Clinics/StatusCell';

export const columns = [
  { field: 'id', headerName: 'ID', width: 100 },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    renderCell: StatusCell,
  },
  {
    field: 'service_name',
    headerName: 'Service Name',
    valueGetter: ({ row }) => row.service.name,
    width: 180,
  },
  {
    field: 'address',
    headerName: 'Address',
    width: 200,
    valueGetter: ({ row }) => row.sublocation.address,
  },
  {
    field: 'city',
    headerName: 'City',
    width: 110,
    valueGetter: ({ row }) => row.sublocation.city,
  },
  {
    field: 'state',
    headerName: 'Province/State',
    width: 180,
    valueGetter: ({ row }) => row.sublocation.state,
  },
  {
    field: 'start_date',
    headerName: 'Start Date',
    type: 'date',
    width: 150,
    valueFormatter: ({ value }) => moment(value).format('MM-DD-YYYY'),
  },
  {
    field: 'end_date',
    headerName: 'End Date',
    type: 'date',
    width: 150,
    valueFormatter: ({ value }) => moment(value).format('MM-DD-YYYY'),
  },
  {
    field: 'start_time',
    headerName: 'Start Time',
    width: 150,
    valueFormatter: ({ value }) => moment(value, 'hh:mm').format('h:mm a'),
  },
  {
    field: 'end_time',
    headerName: 'End Time',
    width: 150,
    valueFormatter: ({ value }) => moment(value, 'hh:mm').format('h:mm a'),
  },
  {
    field: 'booking_cutoff_date',
    headerName: 'Cut Off Date',
    type: 'date',
    width: 170,
  },
  {
    field: 'actual_participants',
    headerName: 'Participants',
    width: 160,
  },
  {
    field: 'available_slots_count',
    headerName: 'Slots',
    width: 110,
  },
  {
    field: 'booked_participants',
    headerName: 'Booked',
    width: 130,
  },
];
